import {FC} from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  ArcElement,
  Tooltip,
  Legend,
  RadialLinearScale,
} from 'chart.js'
import {Bar, PolarArea} from 'react-chartjs-2'
import {DataLrItem} from '../core/_models'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, RadialLinearScale)

type Props = {
  items: DataLrItem[]
}

const LrChart: FC<Props> = ({items}) => {
  const labels = items.map((i) => i.line)

  const dataBar = {
    labels,
    datasets: [
      {
        label: 'Вх.',
        data: items.map((i) => i.incoming_count),
        backgroundColor: 'rgba(54, 162, 235, 0.7)',
        borderWidth: 1,
        borderRadius: 5,
      },
      {
        label: 'Проп.',
        data: items.map((i) => i.missed_count),
        backgroundColor: 'rgba(255, 99, 132, 0.7)',
        borderWidth: 1,
        borderRadius: 5,
      },
      {
        label: 'Уник. Вх.',
        data: items.map((i) => i.incoming_unique_count),
        backgroundColor: 'rgba(54, 168, 235, 0.4)',
        borderWidth: 1,
        borderRadius: 5,
      },
      {
        label: 'Уник. Проп.',
        data: items.map((i) => i.missed_unique_count),
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderWidth: 1,
        borderRadius: 5,
      },
    ],
  }

  const totalInbound = items.reduce((sum, i) => sum + i.incoming_count, 0)
  const totalMissed = items.reduce((sum, i) => sum + i.missed_count, 0)
  const totalUniqueInbound = items.reduce((sum, i) => sum + i.incoming_unique_count, 0)
  const totalUniqueMissed = items.reduce((sum, i) => sum + i.missed_unique_count, 0)

  const dataPolarArea = {
    labels: ['Вх.', 'Проп.', 'Уник. Вх.', 'Уник. Проп.'],
    datasets: [
      {
        label: 'Звонки',
        data: [totalInbound, totalMissed, totalUniqueInbound, totalUniqueMissed],
        backgroundColor: [
          'rgba(54, 162, 235, 0.7)',
          'rgba(255, 99, 132, 0.7)',
          'rgba(54, 168, 235, 0.4)',
          'rgba(255, 99, 132, 0.4)',
        ],
        borderWidth: 1,
        borderRadius: 5,
      },
    ],
  }

  return (
    <div className='row'>
      <div className='col-8'>
        <Bar
          data={dataBar}
          options={{
            responsive: true,
            plugins: {
              legend: {position: 'top'},
            },
          }}
        />
      </div>
      <div className='col-4'>
        <PolarArea
          data={dataPolarArea}
          options={{
            responsive: true,
            plugins: {
              legend: {position: 'top'},
            },
          }}
        />
      </div>
    </div>
  )
}

export {LrChart}
